export enum QuizStatus {
  Available = 0,
  Activated = 1,
  Finished = 2
}
